// Endpoints that involve the user signing in, registering, signing out,
//   checking authentication
export const AuthEndpoint = (DOMAIN: string) => ({
  /*  Param: name, email, token, password
            Response: user_id
            Signs user up with GridLite account, issues a "verify email" email
        */
  REGISTER: `/${DOMAIN}/`,

  /*  Param: name, password, token
            Response: access_token and refresh_token
            Logs user into their GridLite account
        */
  LOGIN: `/${DOMAIN}/auth`,

  /*  Param: refresh_token
            Response: access_token and refresh_token
            Refreshes users authentication, access_token expires in 1 hour, fresh renews lease
        */
  REFRESH: `/${DOMAIN}/authenticate/refresh`,


  /* Param: token
           Response: nothing
           Sends an activation JWT from SignupConfirmation URL to activate the user's account.
        */
  ACTIVATE: `/${DOMAIN}/activate`,

  /* Param: email
           Response: nothing
           Initiates password reset from the public login page.
        */
  INITIATE_FORGOT_PASSWORD: `/${DOMAIN}/password_reset/initiate`,

  AUTHORIZE_FORGOT_PASSWORD: `/${DOMAIN}/password_reset/authorize`,

  /* Param: email
           Response: nothing
           Resends activation email to user
        */
  RETRY_ACTIVATE: `/${DOMAIN}/activate/retry`,
});

export const SuperAdminEndpoint = {
  LOGIN: '/superadmin/auth',
  BRANDS: '/brand/all',
  LOAD: '/superadmin',
};

// Endpoints that involve the user signing in, registering, signing out,
//   checking authentication
export const AdminEndpoint = {
  /*  Param: name, email, token, password
        Response: user_id
        Signs user up with GridLite account, issues a "verify email" email
    */
  REGISTER: '/admin/',

  /*  Param: name, password, token
        Response: access_token and refresh_token
        Logs user into their GridLite account
    */
  LOGIN: '/admin/auth',


  UPDATE: '/admin/brand',

  INVITE: '/admin/invite',

  ACTIVATE: '/admin/activate',

  FETCH: '/admin',

  /*  Param: refresh_token
        Response: access_token and refresh_token
        Refreshes users authentication, access_token expires in 1 hour, fresh renews lease
    */
  REFRESH: '/admin/authenticate/refresh',
  INITIATE_PASSWORD_RESET: '/admin/forgot_password',
  CONFIRM_PASSWORD_RESET: '/admin/forgot_password/confirm',

};

// Endpoints involved in retrieving plan offerings
export const BrandEndpoint = {
  CREATE: '/brand',
  GET: '/brand',
  GET_FOR_BUDTENDER: '/brand/budtender',
  UPDATE: '/brand/update',
  ADD_BUDTENDER_TO_MEETING: '/meeting/attendee',
  CREATE_MEETING: '/meeting',
  UPDATE_MEETING: '/meeting/update',
};

export const BrandProduct = {
  CREATE_PRODUCT: '/product',
  UPDATE_PRODUCT: '/product/update',
  DELETE_PRODUCT: '/product/delete',
  SEARCH_PRODUCT_COA: '/product/coa',
  CREATE_PRODUCT_COA: '/product/coa',
  SEARCH_PRODUCT_COA_BY_BRAND: '/product/coa/by_brand',
};
export const DispensaryEndpoint = {
  FETCH_BY_STATE: '/dispensary/state',
  ADD_DISPENSARY_TO_BRAND: '/dispensary/brand',
  FETCH_BY_BRAND: '/dispensary/brand',
  REMOVE_DISPENSARY_FROM_BRAND: '/dispensary/brand',
}


export const BrandAssetEndpoint = {
  CREATE: '/brand_asset',
  UPDATE: '/brand_asset/update',
  SHARE_ASSET: '/brand_asset/share',
  DELETE: '/brand_asset/delete',
}

export const TagEndpoint = {
  FETCH_ALL: '/tag',
  CREATE: '/tag',
  FETCH_ALL_FOR_BRAND: '/tag/brand',
}

export const CategoryEndpoint = {
  FETCH_ALL: '/category',
  CREATE: '/category',
}

export const BudtenderEndpoint = {
  REGISTER: '/budtender',
  LOGIN: '/budtender/auth',
  FETCH: '/budtender',
  ACTIVATE: '/budtender/activate',
  INVITE: '/budtender/invite',
  INITIATE_PASSWORD_RESET: '/budtender/forgot_password',
  CONFIRM_PASSWORD_RESET: '/budtender/forgot_password/confirm',
}
